import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Wallet } from "lucide-react";
import client from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { signWalletChallenge, walletErrorMessage } from "@/lib/wallet";
import { WalletPicker } from "@/components/wallet/WalletPicker";
import { WalletSignupDialog } from "@/components/wallet/WalletSignupDialog";

export function WalletLoginButton() {
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [signup, setSignup] = useState(null);

  const pick = async (provider) => {
    setBusy(true);
    try {
      const signed = await signWalletChallenge(provider, "login");
      const { data } = await client.post("/auth/wallet/verify", signed);
      setOpen(false);
      if (data.status === "new_wallet") { setSignup(data); return; }
      setSession(data.token, data.user);
      toast.success("Signed in with wallet");
      navigate(data.user.role === "admin" ? "/admin" : "/");
    } catch (e) {
      toast.error(walletErrorMessage(e));
    } finally { setBusy(false); }
  };

  return (
    <>
      <button type="button" data-testid="wallet-signin" onClick={() => setOpen(true)}
        className="w-full mt-3 flex items-center justify-center gap-3 py-3 rounded-full border border-white/15 text-white font-semibold text-sm hover:border-[#ccff00]/50 hover:bg-white/[0.03] transition-colors">
        <Wallet className="w-4 h-4 text-[#ccff00]" /> Continue with wallet
      </button>
      <WalletPicker open={open} onOpenChange={setOpen} onPick={pick} busy={busy} />
      <WalletSignupDialog data={signup} onClose={() => setSignup(null)} />
    </>
  );
}
